var map = {
	"./general/bg-container.jpg": 69889,
	"./general/bg-login.jpg": 3367,
	"./general/default-user.png": 61446,
	"./general/logo-amatra.png": 23907,
	"./general/usericon.png": 86775,
	"./kanisius/alphonsus.png": 21982,
	"./kanisius/cc.png": 27203,
	"./kanisius/ttdJennifer.png": 12725,
	"./kokoro/bg-container.jpg": 46495,
	"./kokoro/bg-login.jpg": 66436,
	"./kokoro/kokoro.png": 45927,
	"./parent/bg-login-mob.png": 23649,
	"./parent/bg-login.png": 14022,
	"./parent/bg-parent-1.png": 21510,
	"./parent/bg-parent-13.png": 8464,
	"./parent/bg-parent-1mob.png": 15006,
	"./parent/bg-parent.png": 44839,
	"./parent/circle-load.png": 71798,
	"./parent/default.png": 93426,
	"./parent/pdf.png": 5467,
	"./parent/user-icon-r.png": 60631,
	"./parent/usericon.png": 72677,
	"./style/customTheme.scss": 16809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97173;